declare global {
    interface Window {
        RAILS_ENV :any;
    }
}

const BRAZE_API_KEY = window.RAILS_ENV === "production" ? 'b505cf8e-da56-4a7d-8f0a-2bb099c65c21' : '904bbe0d-9019-41ac-903d-5eb996f99176'

export {
	BRAZE_API_KEY
};
